import { View } from 'react-native'

import { styled } from '~/core/styled'

export const Container = styled(View, theme => {
  return {
    base: {
      height: 72,
      minWidth: '100%',
      maxHeight: 72,
      minHeight: 72,
      paddingTop: theme.paddingInsetFourpulse,
      paddingBottom: theme.paddingInsetTwopulse,
      paddingLeft: theme.paddingInsetSixpulse,
      gap: theme.paddingInsetTwopulse,
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorContainerBorderDefault,
      borderTopWidth: theme.borderWidthQuarterpulse,
      borderBottomWidth: theme.borderWidthNone,
      borderLeftWidth: theme.borderWidthQuarterpulse,
      borderRightWidth: theme.borderWidthQuarterpulse,
      borderBottomLeftRadius: theme.borderRadiusNone,
      borderBottomRightRadius: theme.borderRadiusNone,
      borderTopLeftRadius: theme.borderRadiusMediumcontainer,
      display: 'flex',
      borderTopRightRadius: theme.borderRadiusMediumcontainer,
      flexDirection: 'row',
      alignItems: 'center',
    },
  }
})
